const angular = require('angular');

const { pickupWizardComponentDefinition } = require('./pickup-wizard.component');

angular.module('wowApp.fulfilment')
    .component('wowPickupWizard', pickupWizardComponentDefinition);



// WEBPACK FOOTER //
// ./src/fulfilment/pickup/index.js